if (!customElements.get('front-back-image')) {
  class FrontBackImage extends HTMLElement {
    constructor() {
      super();
      this.variantChangeUnsubscriber = undefined;
    }

    connectedCallback() {
      const sectionId = this.dataset.sectionId;
      if (!sectionId) return;

      const jsonEl = this.querySelector(`[data-front-back-colors-${sectionId}]`);
      if (!jsonEl) return;

      try {
        this.colorMaps = JSON.parse(jsonEl.textContent);
      } catch {
        return;
      }

      this.sectionId = sectionId;

      this.eventSectionId = sectionId.replace(/^quickadd-/, '');

      this.colorOptionIndex = parseInt(this.dataset.colorOptionIndex, 10);
      if (isNaN(this.colorOptionIndex)) return;

      this.variantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.onVariantChange.bind(this)
      );
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    onVariantChange(event) {
      if (event.data.sectionId !== this.eventSectionId) return;

      const variant = event.data.variant;
      if (!variant) return;

      const selectedColor = variant.options[this.colorOptionIndex];
      if (!selectedColor) return;

      const frontInput = this.querySelector(
        `[data-front-back-input-${this.sectionId}="front"]`
      );
      const backInput = this.querySelector(
        `[data-front-back-input-${this.sectionId}="back"]`
      );

      if (frontInput) {
        const frontUrl = this.colorMaps.front[selectedColor] || '';
        frontInput.value = frontUrl;
        if (frontUrl) {
          frontInput.setAttribute('name', 'properties[select-front]');
        } else {
          frontInput.removeAttribute('name');
        }
      }

      if (backInput) {
        const backUrl = this.colorMaps.back[selectedColor] || '';
        backInput.value = backUrl;
        if (backUrl) {
          backInput.setAttribute('name', 'properties[select-back]');
        } else {
          backInput.removeAttribute('name');
        }
      }
    }
  }

  customElements.define('front-back-image', FrontBackImage);
}
